import { render, staticRenderFns } from "./ZuiXinLunBoBiao.vue?vue&type=template&id=83807d02&scoped=true&"
import script from "./ZuiXinLunBoBiao.vue?vue&type=script&lang=js&"
export * from "./ZuiXinLunBoBiao.vue?vue&type=script&lang=js&"
import style0 from "./ZuiXinLunBoBiao.vue?vue&type=style&index=0&id=83807d02&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83807d02",
  null
  
)

export default component.exports